import React, { useEffect, useState } from 'react';
import Box from '../common/Box';
import { toPercentTime } from '../../../common/utils/convertUtil';

export default function LiveChannelList (props) {
  return (
    <>
      <ul className="live_list_inner">
        {
          props.data.map((item, index) => {
            let type = (props.type === 'virtual') ? '2' : '1';
            let percent = toPercentTime(item.starttime, item.endtime);
            let progress = {
              percent: percent,
              status: `${item.starttime}부터 ${item.endtime} 까지 방송예정, 현재 ${percent} 방송 중`
            }

            let label = [];
            // pc 라디오 대표이미지가 작아서 예외처리 추가
            let thumbnailImgUrl = (item.type === 'Radio' && item.thumbs !== undefined && item.thumbs[640] !== undefined) ? item.thumbs[640] : item.thumbimg;
            thumbnailImgUrl = (thumbnailImgUrl === undefined) ? '/images/sbs.png' : thumbnailImgUrl;

            if (parseInt(item.target_age) >= 19) label.push({ type: '19' });
            if (item.channelid === 'S17' || item.channelid === 'S18') label.push({ type: 'bora' });
            if (item.channelid === 'S01' && item.channelname === 'SBS 카타르 2022' && props.data.filter(element => element.channelid === 'S01').length > 1) {
              return false;
            }

            //FIXME: 가상채널 편성시 채널아이디가 없는 경우가 발생하여 예외처리. 2024-06-21
            if (item.channelid === undefined) return false;

            let channelName = (item.channelid === 'S19') ? '고릴라M' : item.channelname;
            channelName = (channelName === undefined || item.channelid.indexOf('EVENT4') > -1) ? 'SBS' : channelName;
            let ch_info = { title: item.title, desc: channelName }

            return <li key={item.channelid} className="live_list_cont">
              <Box view={true} type={type} imageQuality={75} info={ch_info} img={thumbnailImgUrl} link={(item.channelid === 'EVENT4' && item.homeurl.length > 0) ? item.homeurl : `/live/${item.channelid}`} progress={progress} label={label} clickParams={props.clickParams} />
            </li>
          })
        }
      </ul>
    </>
  );
}
